export const PaymentScenariosTable = ({
  data,
  handleInputChange,
  onBlur,
}: {
  data: Record<string, any>
  handleInputChange: (key: string, value: string | number | any[]) => void
  onBlur: Function
}) => (
  <div className="flex flex-col gap-1">
    <p className="font-semibold">Payment Scenarios</p>
    <table className="w-full text-sm table-fixed font-medium">
      <tbody>
        <tr>
          <td className="m-0 p-2 border font-light">Minimum Monthly Payment Years 1-5 except as noted</td>
          {data?.minMothlyPaymentYear?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.minMothlyPaymentYear]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('minMothlyPaymentYear', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
              {index === 0 && <span className="ml-1">**</span>}
              {index === 4 && <span className="ml-1">**** (1st year only)</span>}
            </td>
          ))}
        </tr>
        <tr>
          <td className="m-0 p-2 border font-light">Monthly Payment in Year 6 with no change in rates</td>
          {data?.monthlyPaymentWithNoChange?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.monthlyPaymentWithNoChange]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('monthlyPaymentWithNoChange', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </td>
          ))}
        </tr>
        <tr>
          <td className="m-0 p-2 border font-light">Monthly Payment in Year 6 with a 2% rise in rates</td>
          {data?.monthlyPaymentwithRiseRate?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.monthlyPaymentwithRiseRate]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('monthlyPaymentwithRiseRate', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </td>
          ))}
        </tr>
        <tr>
          <td className="m-0 p-2 border font-light">Minimum Monthly Payment</td>
          {data?.minMonthlyPayment?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.minMonthlyPayment]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('minMonthlyPayment', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </td>
          ))}
        </tr>
        <tr>
          <td className="m-0 p-2 border font-light">Your Gross Income</td>
          {data?.grossIncome1?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.grossIncome1]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('grossIncome1', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </td>
          ))}
        </tr>
        <tr>
          <td className="m-0 p-2 border font-light">Difference</td>
          {data?.difference1?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.difference1]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('difference1', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  </div>
)

export default PaymentScenariosTable
